export default "__VITE_ASSET__BJ__mWFd__"